import { ExternalLink } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Select } from '@/components/ui/select';

import { AdditionalEmailsInput } from './AdditionalEmailsInput';

import type { PosthogCohortOption } from './proactivity-experiments-types';

const POSTHOG_PROJECT_URL = 'https://us.posthog.com/project/100000';

type CohortFieldsProps = {
  cohorts: PosthogCohortOption[];
  cohortValue: string;
  onCohortValueChange: (cohortValue: string) => void;
  emails: string[];
  onEmailsChange: (emails: string[]) => void;
};

export const CohortFields = ({
  cohorts,
  cohortValue,
  onCohortValueChange,
  emails,
  onEmailsChange,
}: CohortFieldsProps) => {
  const selectedCohort = cohorts.find(
    (cohort) => String(cohort.id) === cohortValue
  );

  return (
    <>
      <div className="grid gap-1.5 text-sm">
        <label htmlFor="cohort">Cohort</label>
        <div className="flex gap-2">
          <Select
            id="cohort"
            name="cohort"
            value={cohortValue}
            onChange={(event) => onCohortValueChange(event.target.value)}
          >
            <option value="">No cohort, additional emails only</option>
            {cohorts.map((cohort) => (
              <option key={cohort.id} value={String(cohort.id)}>
                {cohort.name}
                {cohort.count === null ? '' : ` (${cohort.count})`}
              </option>
            ))}
          </Select>
          {selectedCohort ? (
            <Button variant="outline" className="shrink-0" asChild>
              <a
                href={`${POSTHOG_PROJECT_URL}/cohorts/${selectedCohort.id}`}
                target="_blank"
                rel="noreferrer"
              >
                View cohort
                <ExternalLink className="h-3.5 w-3.5" />
              </a>
            </Button>
          ) : null}
        </div>
      </div>
      <AdditionalEmailsInput emails={emails} onChange={onEmailsChange} />
    </>
  );
};
